import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SalePinState } from '@state/sale_pins';
import { SaleWritState } from '@state/sale_writ';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { SummaryDocketComponent } from '../summary-docket/summary-docket.component';
import { TestHooks } from './overview.hooks';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';
import { TitleSearchComponent } from '../title-search/title-search.component';

const flow = [
	{
		page: TITLE_SEARCH_MATTER_STATE.OVERVIEW,
		index: 0,
		selected: true,
		text: 'PINs',
	},
	{
		page: TITLE_SEARCH_MATTER_STATE.WRITS,
		index: 1,
		selected: false,
		text: 'Writs',
	},
];

@Component({
	selector: 'app-overview',
	templateUrl: './overview.component.html',
	styleUrls: ['./overview.component.scss'],
	standalone: false,
})
export class TeranetOverviewComponent {
	testHooks = TestHooks;
	public ICON = ICON;

	public pages = flow;
	@SelectSnapshot(SelectedMatter.id) matterId;
	@SelectSnapshot(SalePinState.getPrimary) primary;
	@SelectSnapshot(SaleWritState.savedItems) writs;

	constructor(
		private routeService: NavigationService,
		private dialog: MatDialog,
		private drawerService: DrawerService,
	) {}

	goToOverview() {
		this.routeService.goToMatter_TitleSearch(this.matterId);
	}

	goToWrits() {
		this.routeService.goToMatter_TitleSearch_Writs(this.matterId);
	}

	showDocketSummary() {
		this.dialog.open(SummaryDocketComponent, { width: '70vw', height: '80vh' });
	}

	openTitleSearchDrawer() {
		this.drawerService.openDrawer(TitleSearchComponent, {
			title: 'Title Search',
			size: 'lg',
		});
	}
}
